export default __webpack_public_path__ + "9eba1d77abcf2aa6e94e823d52be546b.ttf";